import React from 'react';
import Heading from '@atlaskit/heading/heading';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';

import { useIntl, defineMessage } from '@atlassian/jira-intl';

const extraAuth = defineMessage({
	id: 'applinks.extra-auth.healthcheck-header.extra-auth',
	defaultMessage: 'Extra Auth Healthcheck',
	description:
		'The text is shown as a page header title in the extra authentication healthcheck page. Appears at the top of the page to identify the healthcheck section for extra authenticated application links.',
});

const statusExtra = defineMessage({
	id: 'applinks.extra-auth.healthcheck-header.status-extra',
	defaultMessage: 'Status of Extra Authenticated Application Links for your Jira Cloud site.',
	description:
		'The text is shown as a description paragraph explaining the purpose of the extra authentication healthcheck page. Appears below the page header to provide context about what the healthcheck displays.',
});
const HealthcheckHeader = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Stack space="space.200">
				<Heading size="large">{formatMessage(extraAuth)}</Heading>
				<Text>{formatMessage(statusExtra)}</Text>
			</Stack>
		</>
	);
};

export default HealthcheckHeader;
